var call = "https://shopfront-cdn.tekoapis.com/static/cb825a96c16aeade.svg";

export { call as default };
